import { eRecordingParty } from '../../../ui-toolkit/enums/eRecordingParty';

export const allRecordingPartyOptions: { value: string; label: string }[] = [
  { value: eRecordingParty.Spruce, label: 'Spruce' },
  { value: eRecordingParty.ZillowClosing, label: 'Zillow Closing' },
  { value: eRecordingParty.Lender, label: 'Lender' },
];

export const getRecordingPartyOptions = (isZillowClosingEnabled: boolean) => {
  const excludeValue = isZillowClosingEnabled ? eRecordingParty.Spruce : eRecordingParty.ZillowClosing;
  return allRecordingPartyOptions.filter((option) => option.value !== excludeValue);
};
